/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'

import styles from './Layout.module.scss'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import {
  IconButton,
  Autocomplete,
  TextField,
  CircularProgress,
  Switch,
  Button,
} from '@mui/material'
import moment from 'moment-timezone'
import { logOut } from '../../../core/store/login/auth'
import { IconApp } from '../IconApp/IconApp'

import globals from '../../constants/global.constant'
import { getCompanies } from '../../../core/store/companies/companies'
import {
  getProfile,
  setCompany,
  updateProfile,
  disconnectCalendar,
  setTrackingActivity,
  saveProfileImage,
} from '../../../core/store/common/common'
import { getUserInfo, showForAll, validEmails } from '../../constants/utilities'
import { resetUsers } from '../../../core/store/users/users'
import { resetTeams, resetTeamsTags } from '../../../core/store/teams/teams'
import { validateUpdateProfile } from '../../constants/patterns'
import { Profile } from './Profile'
import { useMediaQuery } from 'react-responsive'
import { MenuResponsive } from './MenuResponsive'

export const Layout = ({ children }) => {
  const muaMobile = useMediaQuery({
    query: `(max-width: 480px)`,
  })

  const dispatch = useDispatch()
  const { auth, companies, common } = useSelector((state) => state)
  const { isSuccessLogOut } = auth
  const { companiesSelect } = companies
  const {
    company,
    user,
    isSuccessSetCalendar,
    isSuccessUpdateUser,
    isLoadingUpdateUser,
    isLoadingUser,
    isLoadingTrackingActivity,
    isSuccessTrackingActivity,
    isSuccessSaveProfileImage,
  } = common
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [forceUpdate, setForceUpdate] = useState(false)
  const [showMenu, setShowMenu] = useState(false)
  const [profileAction, setProfileAction] = useState('profile')
  const [currentModule, setCurrentModule] = useState(
    getUserInfo().isAdministrator ? '1' : '5'
  )

  const [profileSelected, setProfileSelected] = useState(false)
  const [companiesList, setCompaniesList] = useState([])
  const [companySelected, setCompanySelected] = useState(company)
  const [currentEmail, setCurrentEmail] = useState('')
  const [isTrackingActivityChecked, setIsTrackingActivityChecked] = useState(false)
  const [isTrackingActivity, setIsTrackingActivity] = useState(false)
  const [showTrakingMessage, setShowTrakingMessage] = useState(false)
  const [tierHoverMessage, setTierHoverMessage] = useState(false)
  const [profileImage, setProfileImage] = useState(null)
  const [userInfo, setUserInfo] = useState({
    IsActiveNotification: true,
    TimeZone: { Name: '', Offset: '' },
    Calendar: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Id: '',
    IsTrackingActivity: false,
    Tier: '',
    DaysToUpdateTier: 0,
  })
  const [initialUserInfo, setInitialUserInfo] = useState({ ...userInfo })
  const [errorUserInfo, setErrorUserInfo] = useState({
    FirstName: {
      error: false,
    },
    LastName: {
      error: false,
    },
    TimeZone: {
      error: false,
    },
    Calendar: {
      error: false,
    },
    IsActiveNotification: {
      error: false,
    },
    Email: {
      error: false,
    },
  })
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const teamName = params.get('teamName')

  const role = getUserInfo() && getUserInfo().role
  const {
    isAdministrator,
    isEmployee,
    isLead,
    isOwner,
    id: userId,
    companyName,
    userName,
  } = getUserInfo()

  const handleLogout = () => {
    dispatch(setCompany(null))
    dispatch(resetUsers())
    dispatch(resetTeams())
    dispatch(resetTeamsTags())
    dispatch(logOut())
    setForceUpdate(!forceUpdate)
  }

  useEffect(() => {
    if (isAdministrator) {
      dispatch(getCompanies())
    } else {
      dispatch(getProfile(userId))
    }
  }, [role])

  useEffect(() => {
    if (user) {
      const {
        FirstName,
        LastName,
        Email,
        Id,
        TimeZone,
        Calendar,
        IsActiveNotification,
        ProfileImageUrl,
        IsTrackingActivity,
        Tier,
        DaysToUpdateTier,
      } = user
      const newUserInfo = {
        IsActiveNotification,
        TimeZone,
        Calendar: Calendar,
        FirstName: FirstName,
        LastName: LastName,
        Email: Email,
        Id: Id,
        IsTrackingActivity: IsTrackingActivity,
        Tier: Tier,
        DaysToUpdateTier: DaysToUpdateTier,
      }
      setUserInfo(newUserInfo)
      setInitialUserInfo(newUserInfo)
      setCurrentEmail(Email)
      setProfileImage(ProfileImageUrl || null)
      setIsTrackingActivity(IsTrackingActivity)
    }
  }, [user])

  useEffect(() => {
    if (companiesSelect.length > 0) {
      setCompaniesList(
        companiesSelect.map((ele) => ({
          id: ele.Id,
          companyName: ele.Name,
        }))
      )
    }
  }, [companiesSelect])

  useEffect(() => {
    if (isSuccessLogOut) {
      navigate('/')
    }
  }, [isSuccessLogOut, navigate])

  useEffect(() => {
    if (isSuccessTrackingActivity) {
      setShowTrakingMessage(false)
      dispatch(getProfile(userId))
    }
  }, [isSuccessTrackingActivity])

  useEffect(() => {
    if (isSuccessUpdateUser) {
      dispatch(getProfile(userId))
      setProfileAction('profile')
      if (currentEmail !== userInfo.Email) {
        handleLogout()
      }
    }
  }, [isSuccessUpdateUser])

  useEffect(() => {
    if (isSuccessSaveProfileImage) {
      dispatch(getProfile(userId))
    }
  }, [isSuccessSaveProfileImage])

  useEffect(() => {
    if (isSuccessSetCalendar) {
      dispatch(getProfile(userId))
      navigate('/')
      setProfileAction('profile')
    }
  }, [isSuccessSetCalendar])

  const handleSelect = (value) => {
    switch (value) {
      case '1':
        navigate('/companies')
        break
      case '2':
        navigate('/members')
        break
      case '3':
        navigate('/teams')
        break
      case '4':
        navigate('/tags')
        break
      case '5':
        navigate('/activities')
        break
      case '6':
        navigate('/my-progress')
        break
      case '7':
        navigate('/personal-analytics')
        break
      case '8':
        navigate('/team-analytics')
        break
      default:
        break
    }
  }

  const menu = [
    {
      name: 'Companies',
      id: '1',
      permission: isAdministrator,
    },
    {
      name: 'Members',
      id: '2',
      permission: isAdministrator,
    },
    {
      name: 'Teams',
      id: '3',
      permission: isAdministrator,
    },
    {
      name: 'Tags',
      id: '4',
      permission: isAdministrator,
    },
    {
      name: 'My Activities',
      id: '5',
      permission: isEmployee || isLead,
    },
    {
      name: 'My Progress',
      id: '6',
      permission: (isEmployee || isLead) && isTrackingActivity,
    },
    {
      name: 'My Analytics',
      id: '7',
      permission: isEmployee || isLead,
    },
    {
      name: 'My Team',
      id: '8',
      permission: isLead || isOwner,
    },
  ]

  const [hovers, setHovers] = useState(
    Array.from({ length: menu.length }, () => false)
  )

  const handleSelectModule = (event) => {
    const { value } = event.target
    setCurrentModule(value)
    handleSelect(value)
    setForceUpdate(!forceUpdate)
  }

  const handleSelectModuleResponsive = (value) => {
    setCurrentModule(value)
    handleSelect(value)
    setShowMenu(false)
    setProfileSelected(false)
    setForceUpdate(!forceUpdate)
  }

  const handleGoProfile = () => {
    setProfileSelected(true)
    setCurrentModule('0')
    navigate('/profile')
    setShowMenu(false)
  }

  const handleSelectCompany = (value) => {
    const { id } = value
    setCompanySelected(id)
    dispatch(setCompany(id))
    setForceUpdate(!forceUpdate)
  }

  const handleUpdate = () => {
    setProfileAction('update')
  }

  const handleCloseUpdate = () => {
    setProfileAction('profile')
    dispatch(getProfile(userId))
  }

  const handleChange = (event) => {
    const { value, id } = event.target
    setUserInfo((prevUserInfo) => ({
      ...prevUserInfo,
      [id]: value,
    }))

    setErrorUserInfo((prevErrorInfo) => ({
      ...prevErrorInfo,
      [id]: { error: false },
    }))
    setForceUpdate(!forceUpdate)
  }

  const handleSelectCalendar = async (value) => {
    const newUserInfo = userInfo
    newUserInfo.Calendar = value === '1' ? 'Google' : 'Outlook'
    await setUserInfo(newUserInfo)
    dispatch(updateProfile(userId, userInfo))
    setForceUpdate(!forceUpdate)
  }

  const handleSelectNotification = (value) => {
    setUserInfo((prevUserInfo) => ({
      ...prevUserInfo,
      IsActiveNotification: value,
    }))
    setForceUpdate(!forceUpdate)
  }

  const handleSelectTimeZone = (selTimeZone) => {
    setUserInfo((prevUserInfo) => ({
      ...prevUserInfo,
      TimeZone: {
        Name: selTimeZone.id,
        Offset: moment.tz(selTimeZone.id).format('Z'),
      },
    }))
    setForceUpdate(!forceUpdate)
  }

  const handleSave = () => {
    const userInfoToValidate = {
      FirstName: userInfo.FirstName,
      LastName: userInfo.LastName,
      Id: userInfo.Id,
      Email: userInfo.Email,
      Calendar: userInfo.Calendar,
      TimeZone: userInfo.TimeZone,
      IsActiveNotification: userInfo.IsActiveNotification,
    }

    const validation = validateUpdateProfile.validate(userInfoToValidate, {
      abortEarly: false,
    })

    if (validation.error) {
      const newErrorUserInfo = errorUserInfo
      validation.error.details.forEach((ele) => {
        newErrorUserInfo[ele.context.label].error = true
        setErrorUserInfo(newErrorUserInfo)
        setForceUpdate(!forceUpdate)
      })
    } else {
      dispatch(updateProfile(userId, userInfo))
      setForceUpdate(!forceUpdate)
    }
  }

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })
  }

  const handleUploadImage = async (event) => {
    const file = event.target.files[0]

    if (file && file.type.startsWith('image/')) {
      setProfileImage(file)

      let base64Image = null

      if (file instanceof File) {
        const fullBase64 = await fileToBase64(file)
        base64Image = fullBase64.split(',')[1]
      }

      dispatch(
        saveProfileImage(userId, {
          ProfileImageBase64: base64Image,
          ProfileImageFileName: file.name,
        })
      )
    }
  }

  const handleDisconnect = () => {
    dispatch(disconnectCalendar())
  }

  const handleMenu = () => {
    setShowMenu(true)
  }

  const handleClose = () => {
    setShowMenu(false)
  }

  const onEnter = (index) => {
    setHovers(hovers.map((hover, i) => (i === index ? true : hover)))
  }

  const onLeave = (index) => {
    setHovers(hovers.map((hover, i) => (i === index ? false : hover)))
  }

  const getTier = (tier) => {
    switch (tier) {
      case 'Starter':
        return 'starter'
      case 'Pro':
        return 'pro'
      case 'Master':
        return 'master'
      case 'Riser':
        return 'riser'
      default:
        return 'starter'
    }
  }

  const handleSwitch = (event) => {
    const { checked } = event.target
    setIsTrackingActivityChecked(checked)
    setShowTrakingMessage(true)
  }

  const handleTierNo = () => {
    setShowTrakingMessage(false)
  }

  const handleTierYes = () => {
    dispatch(setTrackingActivity(isTrackingActivityChecked))
  }

  const handleLearnMore = () => {
    const url = 'https://support.wemua.com/en/articles/11083346'
    window.open(url, '_blank')
  }

  const hasChanges = () => {
    const currentValues = {
      FirstName: userInfo.FirstName,
      LastName: userInfo.LastName,
      Email: userInfo.Email,
      TimeZone: userInfo.TimeZone?.Name,
      IsActiveNotification: userInfo.IsActiveNotification,
    }

    const initialValues = {
      FirstName: initialUserInfo.FirstName,
      LastName: initialUserInfo.LastName,
      Email: initialUserInfo.Email,
      TimeZone: initialUserInfo.TimeZone?.Name,
      IsActiveNotification: initialUserInfo.IsActiveNotification,
    }

    return JSON.stringify(currentValues) !== JSON.stringify(initialValues)
  }

  const isUserValid = validEmails.includes(userName) || showForAll

  return (
    <div className={styles.layout}>
      {muaMobile ? (
        <div className={styles.navigationResponsive}>
          <div className={styles.menu}>
            <IconButton onClick={handleMenu}>
              <img
                src={`${globals.logosBasePath}menu.svg`}
                alt="menu"
                className={styles.menuButton}
              />
            </IconButton>
          </div>
          <div className={styles.iconMUAResponsive}>
            <img
              src={`${globals.imageBasePath}wordmark_green.png`}
              alt="logo"
              height="30"
            />
          </div>
          <MenuResponsive
            menu={menu}
            showMenu={showMenu}
            handleClose={handleClose}
            handleLogout={handleLogout}
            currentModule={currentModule}
            handleSelectModule={handleSelectModuleResponsive}
            handleGoProfile={handleGoProfile}
            profileSelected={profileSelected}
          />
        </div>
      ) : (
        <div className={styles.navigation}>
          <div className={styles.iconMUA}>
            <img
              src={`${globals.logosBasePath}new_logo.png`}
              alt="logo"
              width="70"
            />
          </div>
          <div className={styles.radioGroup}>
            <RadioGroup
              defaultValue={currentModule}
              onChange={handleSelectModule}
              name="radio-buttons-group"
              sx={{ gap: '30px' }}
            >
              {menu.map(
                (ele, indx) =>
                  ele.permission && (
                    <div key={ele.id} className={styles.radio}>
                      <div
                        id={ele.id}
                        className={styles.tooltip}
                        onMouseEnter={() => onEnter(indx)}
                        onMouseLeave={() => onLeave(indx)}
                      >
                        <Radio
                          className={styles.radioButton}
                          value={ele.id}
                          name="radio-buttons"
                          sx={{
                            color: hovers[indx] ? '#1A3127' : '#4EA7AC',
                            '&.Mui-checked': {
                              color: hovers[indx] ? '#1A3127' : '#4EA7AC',
                            },
                            '& .MuiSvgIcon-root': {
                              fontSize: hovers[indx] ? 20 : 24,
                            },
                            '&:hover': {
                              background: 'transparent',
                            },
                          }}
                        />
                        <p key={ele.id} className={styles.tooltipName}>
                          {ele.name}
                        </p>
                      </div>
                    </div>
                  )
              )}
            </RadioGroup>
          </div>
          <div className={styles.logout}>
            <IconButton onClick={handleLogout}>
              <img
                src={`${globals.logosBasePath}logout.svg`}
                alt="logout"
                className={styles.logoutButton}
              />
            </IconButton>
          </div>
        </div>
      )}

      {role === 'Administrator' ? (
        <div className={styles.wrapperChildrenAdmin}>
          <div className={styles.wrapperHeader}>
            {pathname !== '/companies' && (
              <Autocomplete
                disablePortal
                disableClearable
                noOptionsText="No options"
                id="Companies"
                onChange={(event, value) => handleSelectCompany(value)}
                getOptionLabel={(option) => `${option.companyName}`}
                value={companiesList.find((ele) => ele.id === companySelected)}
                disabled={teamName !== null}
                options={companiesList}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    value={companySelected}
                    placeholder={'Select company'}
                    InputProps={{
                      ...params.InputProps,
                    }}
                    className={styles.textField}
                  />
                )}
              />
            )}
          </div>

          {children}
        </div>
      ) : (
        <>
          <div className={styles.wrapperChildren}>{children}</div>
          {!muaMobile && (
            <div
              className={styles.wrapperProfile}
              style={{
                justifyContent: profileAction === 'profile' && 'center',
                alignItems: profileAction === 'profile' && 'center',
              }}
            >
              {isLoadingUser ? (
                <CircularProgress size="20px" color="light" />
              ) : (
                <>
                  {profileAction === 'profile' ? (
                    <>
                      <div className={styles.updateIcon}>
                        <IconButton onClick={handleUpdate}>
                          <img
                            src={`${globals.logosBasePath}edit.svg`}
                            alt="edit"
                          />
                        </IconButton>
                      </div>
                      <div className={styles.profileInfo}>
                        <div className={styles.profileInfoHeader}>
                          <div
                            className={styles.imageContainer}
                            onClick={handleUpdate}
                          >
                            {profileImage !== null ? (
                              <img src={profileImage} alt="user" />
                            ) : (
                              <img
                                src={`${globals.imageBasePath}profile-image.png`}
                                alt="user"
                              />
                            )}
                          </div>
                          {isUserValid &&
                            (showTrakingMessage ? (
                              <div className={styles.tierMessageContainer}>
                                <div className={styles.tierMessageText}>
                                  {isTrackingActivityChecked
                                    ? 'Turning progress tracking on allows you to visualize your journey within MUA. Are you sure you\'d like to turn progress tracking on?'
                                    : 'Are you sure you\'d like to turn progress tracking off?'}
                                  <span
                                    style={{
                                      textDecoration: 'underline',
                                      cursor: 'pointer',
                                    }}
                                    onClick={handleLearnMore}
                                  >
                                    {' '}
                                    learn more
                                  </span>
                                </div>
                                <div className={styles.tierMessageButton}>
                                  {isLoadingTrackingActivity ? (
                                    <div className={styles.saveButtonWrapper}>
                                      <CircularProgress
                                        size="20px"
                                        color="aqua"
                                        sx={{ marginTop: '14px' }}
                                      />
                                    </div>
                                  ) : (
                                    <div className={styles.tierButtonsWrapper}>
                                      <Button
                                        onClick={handleTierNo}
                                        className={styles.tierButtonNo}
                                      >
                                        <p>No</p>
                                      </Button>
                                      <Button
                                        onClick={handleTierYes}
                                        className={styles.tierButtonYes}
                                      >
                                        <p>Yes</p>
                                      </Button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ) : (
                              <div
                                className={styles.tierContainer}
                                onMouseEnter={() => setTierHoverMessage(true)}
                                onMouseLeave={() => setTierHoverMessage(false)}
                              >
                                <img
                                  src={`${globals.logosBasePath}${getTier(
                                    userInfo.Tier
                                  )}.svg`}
                                  alt={getTier(userInfo.Tier)}
                                  width="90%"
                                  style={{
                                    opacity: isTrackingActivity ? 1 : 0.4,
                                  }}
                                />
                                <div className={styles.tierText}>
                                  {isTrackingActivity
                                    ? 'Stop tracking'
                                    : 'Track progress'}
                                  <Switch
                                    onChange={handleSwitch}
                                    checked={isTrackingActivity}
                                    color="aqua"
                                  />
                                </div>
                                {isTrackingActivity && (
                                  <div className={styles.tierDays}>
                                    {userInfo.DaysToUpdateTier === 0
                                      ? 'Today is the update and it goes back to 14 days'
                                      : `${userInfo.DaysToUpdateTier} days before next level update`}
                                  </div>
                                )}
                                <div
                                  className={styles.tierContainerHelper}
                                  style={{
                                    visibility: tierHoverMessage
                                      ? 'visible'
                                      : 'hidden',
                                  }}
                                >
                                  <div className={styles.tierHelperText}>
                                    This progress bar tracks your progress on
                                    MUA, for more information,{' '}
                                    <span
                                      style={{
                                        textDecoration: 'underline',
                                        cursor: 'pointer',
                                      }}
                                      onClick={handleLearnMore}
                                    >
                                      click here
                                    </span>
                                    .
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                        <div className={styles.userInfo}>
                          <div className={styles.userEmail}>{companyName}</div>
                          {userInfo.Calendar && (
                            <div className={styles.userEmail}>
                              {`Calendar: ${userInfo.Calendar} Calendar`}
                            </div>
                          )}
                          {userInfo.TimeZone?.Name && (
                            <div className={styles.userEmail}>
                              {`Time zone: ${userInfo.TimeZone?.Name}`}
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className={styles.updateIcon}>
                        <IconButton onClick={handleCloseUpdate}>
                          <img
                            src={`${globals.logosBasePath}close-icon.svg`}
                            alt="close"
                          />
                        </IconButton>
                      </div>
                      <Profile
                        isLoadingUpdateUser={isLoadingUpdateUser}
                        handleSave={handleSave}
                        handleChange={handleChange}
                        handleSelectCalendar={handleSelectCalendar}
                        handleDisconnect={handleDisconnect}
                        handleSelectNotification={handleSelectNotification}
                        handleSelectTimeZone={handleSelectTimeZone}
                        userInfo={userInfo}
                        errorUserInfo={errorUserInfo}
                        muaMobile={muaMobile}
                        handleUploadImage={handleUploadImage}
                        currentEmail={currentEmail}
                        setUserInfo={setUserInfo}
                        hasChanges={hasChanges}
                        profileImage={profileImage}
                      />
                    </>
                  )}
                </>
              )}
            </div>
          )}
        </>
      )}
    </div>
  )
}
